export enum SessionType {
    Desktop = 0,
    RemoteApp = 1
}
